export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HOLDING = ["active", "past_due", "trialing", "cancel_scheduled"];

export const STATUS_STYLES = {
  paid: "bg-[#2563EB]/15 text-[#60a5fa]",
  initiated: "bg-white/10 text-white/50",
  open: "bg-white/10 text-white/50",
  expired: "bg-white/10 text-white/40",
};

export const EMPTY_LEAGUE = {
  name: "",
  price: 245,
  spots_total: 24,
  status: "coming_soon",
  league_format: "6 Weeks",
  session_length: "60 Minutes",
  start_date: "",
  end_date: "",
  registration_deadline: "",
  practice_day: "",
  practice_time: "",
  location: "",
  age_groups: "Elementary School Division, Middle School Division, High School Division",
  divisions: "Elementary School Division, Middle School Division, High School Division",
  included: "Weekly Competitive Sessions, Advanced Pitch Profiles, Live Leaderboards, Performance Dashboard, Session Statistics, End-of-Season Rankings",
  tracked: "Exit Velocity, Hard Hit %, Competitive At-Bat %, Sweet Spot %, Personal Bests, Leaderboard Rankings",
  sort_order: 0,
};

export const TEMPLATES = [
  { name: "Membership Opening", subject: "Rep Lab Memberships Are Opening", body: "Hi {{parent_name}},\n\nMemberships for {{player_name}} are opening soon. Spots are limited — reserve your roster spot before they're gone.\n\nSee you at the league." },
  { name: "Registration Reminder", subject: "Reminder: Reserve Your Rep Lab Membership", body: "Hi {{parent_name}},\n\nJust a reminder that {{player_name}}'s membership spot is still available. Complete registration to lock it in." },
  { name: "League Night Reminder", subject: "League Night This Week", body: "Hi {{parent_name}},\n\nReminder that {{player_name}} has league night this week in the {{division}} division. Arrive 15 minutes early to warm up." },
  { name: "Schedule Change", subject: "Schedule Update for {{division}}", body: "Hi {{parent_name}},\n\nWe've updated the {{division}} league night schedule. Please check the new time before your next session." },
  { name: "Weather Update", subject: "Weather Update — League Night", body: "Hi {{parent_name}},\n\nDue to weather, tonight's session has been adjusted. We'll follow up shortly with details." },
  { name: "Season Reset", subject: "A New Season Begins", body: "Hi {{parent_name}},\n\nStandings have reset and a new six-week season starts now. {{player_name}}'s membership continues — time to climb the leaderboard again." },
  { name: "Payment Reminder", subject: "Payment Reminder", body: "Hi {{parent_name}},\n\nWe had trouble processing {{player_name}}'s monthly membership payment. Please update your payment method to keep your roster spot active." },
  { name: "General Announcement", subject: "A Note from Rep Lab", body: "Hi {{parent_name}},\n\n" },
];

export const splitList = (s) => String(s).split(/[\n,]/).map((x) => x.trim()).filter(Boolean);
export const joinList = (a) => (Array.isArray(a) ? a.join(", ") : a || "");

export const PROGRAM_TYPE_OPTIONS = [
  ["hitting", "Rep Lab Hitting"],
  ["pitching", "Rep Lab Pitching"],
  ["strength", "Rep Lab Strength"],
  ["speed", "Rep Lab Speed"],
  ["other", "Rep Lab Training (Other)"],
];

export const PROGRAM_STATUS_OPTIONS = [
  ["draft", "Draft"],
  ["coming_soon", "Coming Soon"],
  ["open", "Open"],
  ["full", "Full"],
  ["closed", "Closed"],
  ["archived", "Archived"],
  ["completed", "Completed"],
];

export const PAYMENT_STATUS_OPTIONS = [
  ["paid", "Paid Online"],
  ["paid_offline", "Paid Offline"],
  ["unpaid", "Unpaid"],
  ["complimentary", "Complimentary"],
  ["refunded", "Refunded"],
  ["initiated", "Incomplete Checkout"],
];

export const MANUAL_PAYMENT_OPTIONS = [
  ["paid_offline", "Paid Offline (cash/check)"],
  ["complimentary", "Complimentary"],
  ["unpaid", "Unpaid"],
  ["paid", "Paid Online"],
];

export const ENROLLMENT_STATUS_OPTIONS = [
  ["active", "Active"],
  ["cancelled", "Cancelled"],
  ["completed", "Completed"],
];

export const DIVISION_OPTIONS = [
  "Youth", "Middle School", "High School", "College", "Open / All Ages",
];

export const PAYMENT_BADGE = {
  paid: "bg-emerald-500/20 text-emerald-300",
  paid_offline: "bg-sky-500/20 text-sky-300",
  complimentary: "bg-violet-500/20 text-violet-300",
  unpaid: "bg-amber-500/20 text-amber-300",
  refunded: "bg-red-500/20 text-red-300",
  initiated: "bg-white/10 text-white/40",
};

export const PAYMENT_LABEL = {
  paid: "Paid Online", paid_offline: "Paid Offline", complimentary: "Complimentary",
  unpaid: "Unpaid", refunded: "Refunded", initiated: "Incomplete",
};

export const PROGRAM_DISPLAY_BADGE = {
  draft: "bg-white/5 text-white/40",
  coming_soon: "bg-white/10 text-white/60",
  open: "bg-emerald-500/20 text-emerald-300",
  limited: "bg-amber-500/20 text-amber-300",
  full: "bg-red-500/20 text-red-300",
  closed: "bg-orange-500/20 text-orange-300",
  archived: "bg-white/5 text-white/30",
  completed: "bg-white/5 text-white/40",
};

export const EMPTY_PROGRAM = {
  program_type: "hitting",
  title: "",
  description: "",
  training_focus: "",
  age_group: "",
  coach: "",
  day: "",
  time: "",
  end_time: "",
  start_date: "",
  end_date: "",
  program_length: "4 Weeks",
  location: "Next Level Development, 11630 W 85th St, Overland Park, KS 66214",
  sessions_count: 4,
  capacity: 6,
  price: 150,
  status: "draft",
  visible: true,
  registration_open_at: "",
  registration_close_at: "",
  sort_order: 0,
  session_minutes: 0,
  special_conditions: "",
  next_program_id: "",
  days: [],
  payment_terms: "paid_in_full",
  renewal_type: "one_time",
};


export const leagueStatusBadge = (status) => {
  if (status === "open") return "bg-[#2563EB] text-white";
  if (status === "coming_soon") return "bg-white/10 text-white/60";
  return "bg-white/5 text-white/40";
};

export function DetailGroup({ title, items }) {
  return (
    <div>
      <p className="text-xs font-bold uppercase tracking-[0.15em] text-[#2563EB]">{title}</p>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5">
        {items.map(([label, value]) => (
          <div key={label} className="flex justify-between gap-3 border-b border-white/5 py-1.5">
            <span className="text-white/40">{label}</span>
            <span className="text-white font-semibold text-right">{value || "—"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Field({ label, value, onChange, type = "text", full, testid }) {
  return (
    <label className={full ? "sm:col-span-2 block" : "block"}>
      <span className="text-xs font-bold uppercase tracking-wider text-white/40">{label}</span>
      <input
        data-testid={testid}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-2 w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-[#2563EB] transition-colors"
      />
    </label>
  );
}

export function SelectField({ label, value, onChange, options, testid }) {
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-wider text-white/40">{label}</span>
      <select
        data-testid={testid}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="mt-2 w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-[#2563EB] transition-colors"
      >
        {options.map(([v, l]) => <option key={v} value={v} className="bg-[#0B0F19]">{l}</option>)}
      </select>
    </label>
  );
}

export function TextArea({ label, value, onChange }) {
  return (
    <label className="sm:col-span-2 block">
      <span className="text-xs font-bold uppercase tracking-wider text-white/40">{label}</span>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={2}
        className="mt-2 w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-[#2563EB] transition-colors resize-none"
      />
    </label>
  );
}
